import * as React from 'react'

function IconVk(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={44}
      height={25}
      viewBox="0 0 44 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.53 24.898h2.63s.794-.088 1.2-.524c.374-.4.361-1.151.361-1.151s-.05-3.515 1.587-4.032c1.615-.511 3.69 3.398 5.885 4.9 1.663 1.135 2.924.886 2.924.886l5.875-.082s3.073-.19 1.616-2.597c-.12-.195-.849-1.779-4.371-5.035-3.684-3.407-3.19-2.855 1.248-8.748 2.702-3.587 3.785-5.78 3.446-6.717-.323-.893-2.31-.656-2.31-.656l-6.616.04s-.491-.065-.855.152c-.355.212-.583.707-.583.707s-1.049 2.776-2.445 5.14c-2.946 4.98-4.125 5.246-4.606 4.936-1.121-.722-.84-2.896-.84-4.442 0-4.83.736-6.842-1.431-7.363-.72-.174-1.248-.287-3.088-.306-2.36-.025-4.359.006-5.49.558-.753.366-1.333 1.187-.978 1.234.437.057 1.428.265 1.95.978.679.918.657 2.981.657 2.981s.39 5.685-.91 6.392c-.893.486-2.115-.505-4.741-5.026C10.298 4.808 9.282 2.25 9.282 2.25s-.197-.48-.545-.735c-.425-.31-1.017-.407-1.017-.407l-6.287.041s-.944.025-1.29.435C-.164 1.946.118 2.7.118 2.7S5.04 14.171 10.615 19.951c5.112 5.294 10.915 4.947 10.915 4.947z"
        fill="#C4C4C4"
      />
    </svg>
  )
}

export default IconVk
